import type { VariableTriggerConfig } from '@lighthouse/shared'
import { TooltipText } from '@lighthouse/shared'
import { Tooltip } from '@mantine/core'
import React, { useMemo } from 'react'

import { typeName } from '../../../OutputVariable'
import * as CM from '../styles'
import * as SC from './styles'

type ArgTriggerCardProps = {
    config: VariableTriggerConfig
}

const ArgTriggerCard: React.FC<ArgTriggerCardProps> = ({ config }) => {
    const { args } = config
    if (args.length === 0) {
        return null
    }
    return (
        <CM.CardItemContainer>
            <SC.TypeName>传入子流程的参数</SC.TypeName>
            <CM.FieldList>
                {args.map(item => (
                    <CM.FieldItem key={item.id}>
                        <TooltipText title={item.name} render={ref => <CM.FieldItemTitle ref={ref}>{item.name}</CM.FieldItemTitle>} />
                        <SC.FieldItemRightTitle>{typeName(item.innerType)}</SC.FieldItemRightTitle>
                    </CM.FieldItem>
                ))}
            </CM.FieldList>
        </CM.CardItemContainer>
    )
}

export default ArgTriggerCard
